import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ReactSelect from 'react-select';

import '../ccm/Modal.css';
import { ButtonBlack, ButtonRed, ButtonWhite } from '../reusable';

import StoreMultiSelect from './StoreMultiSelect';

export const FULFILLMENT_TYPES = [
  { label: 'BOPIS - Buy Online Pick-up In Store', value: 'BOPIS' },
  { label: 'Ship From Store (SFS)', value: 'SHIP_FROM_STORE' },
];

const Step1SelectStores = ({
  fulfillmentOption,
  selectedCountry,
  selectedStores,
  hasCachedValues,
  onChangeFulfillmentOption,
  onChangeCountry,
  onChangeSelected,
  onNext,
}) => {
  const [pendingFulfillmentChange, setPendingFulfillmentChange] = useState(null);
  const [pendingCountryChange, setPendingCountryChange] = useState(null);

  const requestFulfillmentChange = (option) => {
    if (!option || option.value === (fulfillmentOption && fulfillmentOption.value)) return;
    if (hasCachedValues || selectedStores.length > 0) {
      setPendingFulfillmentChange(option);
    } else {
      onChangeFulfillmentOption(option);
    }
  };

  const confirmFulfillmentChange = () => {
    onChangeFulfillmentOption(pendingFulfillmentChange);
    setPendingFulfillmentChange(null);
  };

  const requestCountryChange = (option) => {
    if (!option || (selectedCountry && option.value === selectedCountry.value)) return;
    if (selectedStores.length > 0) {
      setPendingCountryChange(option);
    } else {
      onChangeCountry(option);
    }
  };

  const confirmCountryChange = () => {
    onChangeCountry(pendingCountryChange);
    setPendingCountryChange(null);
  };

  const canProceed = Boolean(fulfillmentOption) && selectedStores.length > 0;

  return (
    <section className="o2o-bulk-step1">
      <article className="o2o-bulk-step1-header">
        <article className="o2o-bulk-step1-header-item">
          <label className="o2o-bulk-field-label" htmlFor="o2o-bulk-fulfillment-type">Fulfillment Type</label>
          <ReactSelect
            classNamePrefix="react-select"
            clearable={false}
            id="o2o-bulk-fulfillment-type"
            options={FULFILLMENT_TYPES}
            placeholder="Select a fulfillment type"
            styles={{
              container: (s) => ({ ...s, zIndex: 120 }),
              control: (s) => ({
                ...s, borderColor: 'lightgrey', padding: '0px 0px 0px 3px',
              }),
            }}
            value={fulfillmentOption}
            onChange={requestFulfillmentChange}
          />
        </article>
        <article className="o2o-bulk-step1-header-item">
          {!fulfillmentOption && (
            <p className="o2o-bulk-step1-hint">Pick a fulfillment type, then a country, to choose stores.</p>
          )}
        </article>
      </article>

      {fulfillmentOption && (
        <StoreMultiSelect
          selectedCountry={selectedCountry}
          selectedStores={selectedStores}
          onChangeCountry={requestCountryChange}
          onChangeSelected={onChangeSelected}
        />
      )}

      <article className="o2o-bulk-step1-footer">
        <ButtonBlack
          isDisabled={!canProceed}
          label={`Next: Configure (${selectedStores.length} store${selectedStores.length === 1 ? '' : 's'})`}
          onClick={onNext}
        />
      </article>

      {pendingFulfillmentChange && (
        <div className="modal-overlay">
          <div className="modal-content o2o-bulk-confirm-modal">
            <h2 className="headline-2">Switch fulfillment type?</h2>
            <div className="o2o-bulk-confirm-body">
              <p>
                Switching to <strong>{pendingFulfillmentChange.label}</strong>
                {' '}
                will discard any values you&apos;ve loaded or edited so far. Your
                {' '}
                <strong>{selectedStores.length}</strong>
                {' '}
                selected store
                {selectedStores.length === 1 ? '' : 's'}
                {' '}
                will be kept, so you can continue on the next step.
              </p>
            </div>
            <div className="o2o-bulk-confirm-actions">
              <ButtonWhite className="border" label="Cancel" onClick={() => setPendingFulfillmentChange(null)} />
              <ButtonRed confirm={false} label="Confirm" onClick={confirmFulfillmentChange} />
            </div>
          </div>
        </div>
      )}

      {pendingCountryChange && (
        <div className="modal-overlay">
          <div className="modal-content o2o-bulk-confirm-modal">
            <h2 className="headline-2">Confirm Country Change</h2>
            <div className="o2o-bulk-confirm-body">
              <p>
                {`Switching to ${pendingCountryChange.label} will clear your ${selectedStores.length} selected store${selectedStores.length === 1 ? '' : 's'}.`}
              </p>
            </div>
            <div className="o2o-bulk-confirm-actions">
              <ButtonWhite className="border" label="Cancel" onClick={() => setPendingCountryChange(null)} />
              <ButtonRed confirm={false} label="Confirm" onClick={confirmCountryChange} />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

Step1SelectStores.defaultProps = {
  fulfillmentOption: null,
  hasCachedValues: false,
  selectedCountry: null,
};

Step1SelectStores.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fulfillmentOption: PropTypes.object,

  hasCachedValues: PropTypes.bool,

onChangeCountry: PropTypes.func.isRequired,

onChangeFulfillmentOption: PropTypes.func.isRequired,

onChangeSelected: PropTypes.func.isRequired,

onNext: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
selectedCountry: PropTypes.object,
  selectedStores: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string.isRequired })).isRequired,
};

export default Step1SelectStores;
